import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Sample } from '@app/modules/service-data/types/sample.types';
import { AwbService } from '@core/services/awb.service';
import { DataTableComponent } from '@shared/components/data-table/data-table.component';
import {
  DataTableActionType,
  DataTableActionsLocation,
  DataTableConfiguration,
  DataTableSelectionType,
} from '@shared/components/data-table/data-table.types';
import { Observable, first, map, of } from 'rxjs';

@Component({
  selector: 'app-sample-details-dhl-waybill',
  imports: [DataTableComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './sample-details-dhl-waybill.component.html',
})
export class SampleDetailsDhlWaybillComponent implements OnInit {
  private awbService = inject(AwbService);

  @Output() showPDF = new EventEmitter();
  @Input() sample: Sample;

  protected dataTableConfiguration: DataTableConfiguration;

  ngOnInit(): void {
    const rows$ = of(this.sample).pipe(
      map((sample) => [
        {
          fileName: `${sample.shippingInformation.waybill}-waybill.pdf`,
          documentId: sample.shippingInformation.documentId,
        },
      ])
    );

    this.dataTableConfiguration = {
      title: '',
      selectionMode: DataTableSelectionType.NONE,
      actionsLocation: DataTableActionsLocation.RIGHT,
      tableHeadClasses: '',
      tableCellClasses: 'align-middle',
      singleActions: [
        {
          type: DataTableActionType.BUTTON,
          name: 'common.previewDocument',
          icon: 'fa-light fa-file-lines',
          action: this.onPreviewDocument.bind(this),
        },
      ],
      columns: [
        {
          label: 'sample.details.documentFileName',
          property: 'fileName',
          customStyle: 'font-weight: bold',
        },
      ],
      actionsClasses: 'w-15 text-end',
      rows$: rows$,
    };

    this.getWaybillUri().subscribe((uri: string) => this.showPDF.emit(uri));
  }

  private getWaybillUri(): Observable<string> {
    return this.awbService
      .getWaybill(this.sample.shippingInformation.documentId)
      .pipe(
        first(),
        map(({ payload }) => {
          // decode base64 string, remove space for IE compatibility
          const binary = atob(payload.replace(/\s/g, ''));
          const len = binary.length;
          const buffer = new ArrayBuffer(len);
          const view = new Uint8Array(buffer);
          for (let i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
          }
          const newBlob = new Blob([view], { type: 'application/pdf' });

          return window.URL.createObjectURL(newBlob);
        })
      );
  }

  private onPreviewDocument(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    this.getWaybillUri().subscribe((uri: string) => window.open(uri, 'blank'));
  }
}
